import React, { useState, useMemo } from 'react';
import { CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import './PanelsStatus.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { getFormatDateTimeMillisecondsItFormat } from '../../../utils/CommonUtilities';
import Tooltip from '@mui/material/Tooltip';
import CustomToolbar from 'components/CustomToolbar';
import { styled } from '@mui/material/styles';
import { EditIcon } from '../../../assets/icons/icons';
import PanelsStatusSetStatusModel from './PanelsStatusSetStatusModel';

const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976d2' },
        },
    },
    itIT,
);

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip describeChild {...props} classes={{ popper: className }} placement='left'/>
))(({ theme }) => ({
}));

const OperativityCell = (params, roleUser, createBlocksLineStructure, logsSources, getPanelFileStatus, SquareLog) => {

    let severityResult = undefined;

    if(typeof params?.row[params.field]?.severity === 'number' && params.field !== 'operativityLevel'){
        severityResult = params?.row[params.field]?.severity
    }else if(params.field !== 'operativityLevel'){
        let severityColor = 3;
        for (let index = 0; index < params?.row[params.field]?.severity.length; index++) {
            const element = params?.row[params.field]?.severity[index];
            if(element.severity < severityColor)severityColor = element.severity;
            //questo blocco è da rimuovere una volta ridefinite le regole dei colori
            //per ora su richiesta di mauro se trovo un verde, il pannello è vivo


            //if(element.severity > severityColor)severityColor = element.severity;
        }
        severityResult = severityColor;
    }

    return(
        <HtmlTooltip
            className={"remove-bckg-tooltip"}
            title={
            <React.Fragment>
                <div className='info-window-table'>
                    <div className='panel-title'>{params?.row.key}</div>
                    {roleUser!=='MU' ? (<div className='logs-wrapper'>
                        <div className='logs-box'>
                            {createBlocksLineStructure(logsSources, params?.row?.logs?.severity || 3, params?.row?.logs?.lastUpdateDate, params?.row.status).map(el => <SquareLog {...{el}}/>)}
                        </div>
                        {(params?.row.status?.severity<3)&&(
                            <div className='status- box'>
                                {params?.row.status.status}
                            </div>
                        )}
                    </div>)
                    : <span>{getPanelFileStatus(params?.row.panelStatus)}</span>
                    }
                </div>
            </React.Fragment>
            }
        >   
            <div className='block-wrapper'>
                { params.field !== 'operativityLevel' ?
                    <div className={`block block-${severityResult}`}></div>
                    :
                    <div className={`block block-operativity-${params.value}`}></div>
                }
            </div>
        </HtmlTooltip>
        
    )
}

function CustomToolbarWithReload(props) {
    return (
        <CustomToolbar {...props}>
            <IconButton title='Ricarica dati' onClick={props.getMonitorData} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
        </CustomToolbar>
    );
}

function assignValueToColumn(p){
    let severityColor = 3;
    if(Array.isArray(p?.lastUpdateDate)){
        for (let index = 0; index < p?.severity?.length; index++) {
            const element = p?.severity[index];
            if(element.severity<severityColor)severityColor = element.severity;
        }
    }else if(typeof p?.lastUpdateDate === 'string'){
        if(p.severity<severityColor)severityColor = p.severity;
    }
    
    return severityColor === 0 ? 'V' : severityColor === 2 ? 'A' : 'R'
}

/* function assignValueToColumnOperativity(p){    
    return p === 0 ? 'V' : p === 2 ? 'A' : 'R'
}
 */
const arrStatus = {
    "Y": "Attivo",
    "N": "Non Attivo",
    "G": "Guasto",
    "NS": "Non in Servizio"
}

function getMaxDateForLastUpdate(logsArr, statusArr){
    let onlyDates = logsArr.map(el => el.dateTime);

    onlyDates.push(statusArr);
    onlyDates.sort((a, b) => b - a);

    return onlyDates[0] || null;
}

// Costanti per identificare in modo univoco i due filtri esterni
const ID_FILTER_TIPOLOGIA = 'ext-filter-tipologia';
const ID_FILTER_OPERATIVITA = 'ext-filter-operativita';

const ActionCell = (openSetStatusDialog) => {
    return(
        <div>
            <IconButton onClick={openSetStatusDialog} size='small'>
                <EditIcon addClass="pointer" ></EditIcon>
            </IconButton>
        </div>
    )
}

function PanelsStatusTable(props) {
    const {filterPanelsOperativity, tipologiaFilter} = props;
    const [openPanelSetStatusDialog, setOpenPanelSetStatusDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);
    const monitorData = props.monitorData.filter(el => (el.panelStatus === 'Y' || el.panelStatus === 'G'));
    const loading = props.loading;
    const columns = [
        {field: 'idEntita', headerClassName: 'header-cell idImpianto', headerName: 'Id Impianto', type: 'string', width: 150, align: 'right', headerAlign: 'right'},
        {field: 'idFermata', headerClassName: 'header-cell idFermata', headerName: 'Id Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left'},
        {field: 'nome', headerClassName: 'header-cell nome', headerName: 'Nome Fermata', type: 'string', flex: 1, align: 'left', headerAlign: 'left'},
        {field: 'lat', headerClassName: 'header-cell lat', headerName: 'Latitudine', type: 'string', flex: 1, align: 'left', headerAlign: 'left'},
        {field: 'lon', headerClassName: 'header-cell lon', headerName: 'Longitudine', type: 'string', flex: 1, align: 'left', headerAlign: 'left'},
        {field: 'lastUpdateDate', headerClassName: 'header-cell lastUpdateDate', headerName: 'Ultima data di attività', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params, row) => getMaxDateForLastUpdate(row?.logs?.lastUpdateDate || [], row?.status?.lastUpdateDate || undefined), valueFormatter: (params) => params ? getFormatDateTimeMillisecondsItFormat(params) : ''},
        {field: 'tipologia', headerClassName: 'header-cell tipologia', headerName: 'Tipologia', type: 'string', flex: 1, align: 'left', headerAlign: 'left', filterable: false, valueFormatter: (params) => params === 'T' ? 'Totem' : 'Palina'},
        {field: 'logs', headerClassName: 'header-cell logs-severity-result', headerName: 'Logs', type: 'string', width: 100, align: 'left', headerAlign: 'left', renderCell: (params) => OperativityCell(params, props.roleUser, props.createBlocksLineStructure, props.logsSources, props.getPanelFileStatus, props.SquareLog), valueGetter: (params) => assignValueToColumn(params),
            description: `V => Verde => Almeno una chiamata nelle ultime 2 ore\nA => Arancione => Almeno una chiamata nelle ultime 24 ore\nR => Rosso => Nessuna chiamata dopo 1 giorno`
        },
        {field: 'status', headerClassName: 'header-cell status-severity-result', headerName: 'Status', type: 'string', width: 100, align: 'left', headerAlign: 'left', renderCell: (params) => OperativityCell(params, props.roleUser, props.createBlocksLineStructure, props.logsSources, props.getPanelFileStatus, props.SquareLog), valueGetter: (params) => assignValueToColumn(params),
            description: `V => Verde => Almeno una chiamata nelle ultime 2 ore\nA => Arancione => Almeno una chiamata nelle ultime 24 ore\nR => Rosso => Nessuna chiamata dopo 1 giorno`
        },
        {field: 'operativityLevel', headerClassName: 'header-cell operativityLevel', headerName: 'Operatività', type: 'string', width: 100, align: 'left', headerAlign: 'left', filterable: false, renderCell: (params) => OperativityCell(params, props.roleUser, props.createBlocksLineStructure, props.logsSources, props.getPanelFileStatus, props.SquareLog), valueGetter: (params) => params.toString()/* assignValueToColumnOperativity(params) */,
            description: `V => Verde => Almeno una chiamata nelle ultime 2 ore\nA => Arancione => Almeno una chiamata nelle ultime 24 ore\nR => Rosso => Nessuna chiamata dopo 1 giorno`},
        {field: 'panelStatus', headerClassName: 'header-cell panelStatus', headerName: 'Stato Pannello', type: 'string', width: 100, align: 'left', headerAlign: 'left', valueGetter: (params) => arrStatus[params] },
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 50, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, filterable: false, renderCell: (params) => ActionCell(handleOpenPanelSetStatusDialog)},
    ];
        
    const columnVisibilityModel = {
        logs: false,
        status: false
    }
    
    const handleOpenPanelSetStatusDialog = () => {
        setOpenPanelSetStatusDialog(true);
    }   
    const handleClosePanelSetStatusDialog = () => {
        setOpenPanelSetStatusDialog(false);
    }

    // 1. Stato locale SOLO per i filtri impostati dall'utente DENTRO la griglia
    const [internalFilterModel, setInternalFilterModel] = useState({
        items: [],
    });

    // 2. Unione sincrona delle 2 Props + Stato Interno della DataGrid
    const effectiveFilterModel = useMemo(() => {
        // A) Isoli i filtri nati dentro la tabella (escludendo gli ID dei filtri esterni)
        const baseItems = internalFilterModel.items.filter(
            (item) => item.id !== ID_FILTER_TIPOLOGIA && item.id !== ID_FILTER_OPERATIVITA
        );

        // B) Costruisci l'array dei filtri esterni attualmente attivi
        const externalItems = [];
        if (tipologiaFilter !== 'A' ) {
            externalItems.push({
                id: ID_FILTER_TIPOLOGIA,
                field: 'tipologia', // Nome della colonna target per il testo
                operator: 'equals',
                value: tipologiaFilter,
            });
        }

        if(filterPanelsOperativity === 9){
            externalItems.push({
                id: ID_FILTER_OPERATIVITA,
                field: 'panelStatus',
                operator: 'equals',
                value: "Guasto",
            });
        } else if(filterPanelsOperativity || filterPanelsOperativity === 0) {
            //lo 0 è per tracciare il verde come colore operatività
            externalItems.push({
                id: ID_FILTER_OPERATIVITA,
                field: 'operativityLevel', // Nome della colonna target per lo stato
                operator: 'equals',
                value: filterPanelsOperativity.toString(),
            });
        }

        // C) Restituisci la fusione dei due gruppi di filtri
        return {
            ...internalFilterModel,
            items: [...baseItems, ...externalItems],
        };
    }, [tipologiaFilter, filterPanelsOperativity, internalFilterModel]);

    return (
        <>
            <ThemeProvider theme={theme}>
                <DataGridPremium
                    rows={monitorData}
                    columns={columns}
                    className="panels-status-table"
                    loading={loading}
                    rowHeight={30}
                    getRowId={(row) => row.idEntita}
                    disableAggregation
                    disableRowGrouping
                    disableDensitySelector
                    disablePivoting
                    showToolbar
                    onCellClick={(params) => {console.log(params.row);setLastCellData(params.row)}}
                    slots={{
                        toolbar: CustomToolbarWithReload,
                    }}
                    initialState = {{
                        columns: {
                            columnVisibilityModel
                        }
                    }}
                    slotProps={{
                        toolbar: {
                            elements: ['columns', 'filters', 'export', 'quickFilter'],
                            getMonitorData: props.getMonitoringData,
                            printOptions: { disableToolbarButton: true }, 
                            csvOptions: { fileName: `maps_logs_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                            excelOptions: { fileName: `maps_logs_${new Date().getFullYear()}${(new Date().getMonth()+1).toString().padStart(2, '0')}${new Date().getDate().toString().padStart(2, '0')}${new Date().getHours().toString().padStart(2, '0')}${new Date().getMinutes().toString().padStart(2, '0')}`},
                        }
                    }}
                    filterModel={effectiveFilterModel}
                    onFilterModelChange={(newModel) => setInternalFilterModel(newModel)}
                />
            </ThemeProvider>
            <PanelsStatusSetStatusModel {...{
                openPanelSetStatusDialog,
                handleClosePanelSetStatusDialog,
                lastCellData,
                getMonitoringData: props.getMonitoringData,
                logOut: props.logOut
            }}/>
        </>
    )
}

export default PanelsStatusTable